module.exports = __webpack_public_path__ + "img/ic_dic_music4.12c9ecac.png";